import { useState } from "react";

import { useRouter } from "../../router/Router";
import { SIG_DESCS, TIERS, calcBlockSize } from "./sizing";

const scores = [1, 2, 3, 4, 5];

// The Sizer/Calculator previews Impact×Significance → block size with the exact
// formula the server applies when scoring a top block (calcBlockSize), plus an
// optional override preview. It performs no write (req §9 / Appendix D, port of
// updateCalc); it needs only blocks:view, which App.tsx already gates.
export function SizerPage() {
  const router = useRouter();
  const [impact, setImpact] = useState(3);
  const [significance, setSignificance] = useState(3);
  const [override, setOverride] = useState("");

  const tier = TIERS[impact];
  const calc = calcBlockSize(impact, significance);
  const overrideNum = override.trim() === "" ? null : Number(override);
  const overrideValid = overrideNum !== null && Number.isFinite(overrideNum) && overrideNum >= 0;
  const finalSize = overrideValid ? overrideNum : calc;

  return (
    <div className="blocks-view">
      <section className="card">
        <button type="button" className="block-detail__back" onClick={() => router.navigate("/blocks")}>
          ← Dashboard
        </button>
        <h2>Block Sizer</h2>
        <p className="muted">
          Impact selects the size bracket; Significance positions the block within it. The size below uses the same
          formula the server applies when scoring a top block.
        </p>

        <div className="form-row form-row--inline">
          <label>
            Impact (Tier)
            <select value={impact} onChange={(event) => setImpact(Number(event.target.value))}>
              {scores.map((value) => (
                <option key={value} value={value}>
                  {value}
                </option>
              ))}
            </select>
          </label>
          <label>
            Significance
            <select value={significance} onChange={(event) => setSignificance(Number(event.target.value))}>
              {scores.map((value) => (
                <option key={value} value={value}>
                  {value}
                </option>
              ))}
            </select>
          </label>
          <label>
            Override (optional)
            <input
              type="number"
              min={0}
              value={override}
              onChange={(event) => setOverride(event.target.value)}
              placeholder="—"
            />
          </label>
        </div>

        <p className="muted">
          <strong>Tier {impact}:</strong> {tier.desc} · Range {tier.min}–{tier.max}
        </p>
        <p className="muted">
          <strong>Significance {significance}:</strong> {SIG_DESCS[significance]}
        </p>

        <div className="score-box-row">
          <div className="score-box">
            <div className="score-box__value">{calc}</div>
            <div className="score-box__label">Calculated</div>
          </div>
          <div className="score-box">
            <div className="score-box__value">{finalSize}</div>
            <div className="score-box__label">Final Size</div>
          </div>
        </div>
        <p className="muted">
          {overrideValid ? `Override applied — calculated was ${calc}.` : "Calculated — no override applied."}
        </p>
      </section>
    </div>
  );
}
